import { FETCH_SUSPENSION_REASONS_SUCCESS } from '../action_types';

export default (suspensionReasons) => ({
  type: FETCH_SUSPENSION_REASONS_SUCCESS,
  suspensionReasons,
});
